var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "b-browse",
      class: { "with-pagination": true, demo: _vm.isDemo },
      style: {
        minHeight: "150px",
        borderBottomRightRadius: _vm.borderBottomRightRadius,
      },
    },
    [
      _vm.state.fetching
        ? _c(
            "div",
            {
              staticClass: "spinner-overlay",
              style: {
                backgroundColor: !_vm.spinnerShown ? "#ededed" : undefined,
              },
            },
            [
              _c("app-delayed-progress", {
                model: {
                  value: _vm.spinnerShown,
                  callback: function ($$v) {
                    _vm.spinnerShown = $$v
                  },
                  expression: "spinnerShown",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("w-data-table", {
        staticClass: "browse-table",
        style: { flexGrow: 1 },
        attrs: {
          items: _vm.items,
          "selected-items": _vm.selectedItems,
          columns: _vm.columns,
          "order-column": _vm.querySettings.orderBy,
          "order-direction": _vm.querySettings.orderDirection == "DESC",
          "empty-label": _vm.emptyLabel,
          "use-checkboxes": _vm.useCheckboxes,
          compact: _vm.useCompactView,
          "get-style-function": _vm.getStyleFunction,
          compare: _vm.state.dataSource.compareFunc,
          "column-resize-handle": "",
        },
        on: {
          order: function ($event) {
            return _vm.onOrderChanged($event)
          },
          scroll: function ($event) {
            return _vm.onScroll($event)
          },
          "item-clicked": function ($event) {
            return _vm.openItem($event)
          },
          contextmenu: function ($event) {
            return _vm.onContextMenuClick($event)
          },
          "header-right-click": function ($event) {
            return _vm.state.onHeaderSearchClicked($event.column)
          },
          "new-column-width": function ($event) {
            return _vm.onNewColumnWidth($event)
          },
        },
      }),
      _vm.jsonViewerObject
        ? _c(
            "w-modal",
            { attrs: { value: _vm.jsonViewerObject != null } },
            [
              _c("app-json-viewer-modal", {
                attrs: { value: _vm.jsonViewerObject },
                on: {
                  close: function ($event) {
                    _vm.jsonViewerObject = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("app-browse-context-menu", { attrs: { state: _vm.state } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }